@if (!isAuthenticating) {
  <div class="content">
    <h1 class="title">Please Login</h1>
    <div class="wrapper">
      <div class="image">
        <i class="fa-solid fa-lock"></i>
      </div>
      @if (isLoading) {
        <daui-waiting-indicator class="loader"></daui-waiting-indicator>
      }
      @if (!isLoading) {
        <div class="actions">
          <button class="action login" (click)="login()">
            <i class="picto fa-solid fa-right-to-bracket"></i>
            <span class="label">Login</span>
          </button>
        </div>
      }
    </div>
  </div>
}
@if (isAuthenticating) {
  <div class="content loader">
    <daui-waiting-indicator class="loader"></daui-waiting-indicator>
  </div>
}
<app-footer-actions> </app-footer-actions>
